import React from "react";
import "react-chat-widget/lib/styles.css";

const Chatbot = () => {
  return <></>;
};
export default Chatbot;
